<div class="ms-CommandBar">
  <div class="ms-CommandBar-sideCommands user-section">


      <div class="ms-ContextualMenuExample">
        <button class="ms-Button ms-Button--icon notification-button" (click)="toggleNotificationsMenu()">
          <i class="ms-Icon ms-Icon--Ringer"></i>
          <span class="ms-Badge ms-Badge--notification" *ngIf="notificationsCount > 0">{{ notificationsCount }}</span>
        </button>
        <ul class="ms-ContextualMenu notifications-menu" [class.is-hidden]="!notificationsMenuOpen">
          <li class="ms-ContextualMenu-item" style="cursor: default; color: inherit; text-decoration: none;" *ngFor="let notification of notifications" >
            <span  style="cursor: default; color: inherit; text-decoration: none;">
              {{ notification.text }}
            </span>
          </li>
          <li *ngIf="notifications && notifications.length === 0" class="ms-ContextualMenu-item">
            <span >No hay tareas</span>
          </li>
          <li class="ms-ContextualMenu-item">
            <a class="ms-ContextualMenu-link" style="color: blue; text-decoration: underline;" (click)="navigateToTareas()">
              Ver todas las tareas
            </a>
          </li>
        
        </ul>
      </div>

    <div class="ms-ContextualMenuExample">
      <button class="ms-Button ms-Button--primary">
        <span class="ms-CommandButton-icon"
          ><i class="ms-Icon ms-Icon--FollowUser" style="color: white"></i
        ></span>
        <span class="ms-Button-label">{{ username }}</span>
      </button>
      <ul class="ms-ContextualMenu is-hidden">
        <li class="ms-ContextualMenu-item">
          <a
            (click)="confirmLogOut()"
            class="ms-ContextualMenu-link"
            tabindex="1"
            ><i class="ms-Icon ms-Icon--SignOut"></i> Cerrar Sesión</a
          >
        </li>
      </ul>
    </div>

    <!-- <button type="button" class="ms-CommandButton-button" >
        <span class="ms-CommandButton-icon"><i class="ms-Icon ms-Icon--FollowUser" style="color: white;"></i></span>
        <span class="ms-CommandButton-label" style="color: white;">Cerrar sesiobn pba</span>
      </button> -->
  </div>
  <div class="ms-CommandBar-mainArea"></div>
</div>

<!-- Confirmar logout -->

<div class="docs-DialogExample-lgHeader warning">
  <div class="ms-Dialog ms-Dialog--lgHeader logout-modal" appPreventOutsideClick>
    <div class="ms-Dialog-title">Cerrar Sesión</div>
    <div class="ms-Dialog-content">
      <div class="ms-Grid" dir="ltr">
        <div class="ms-Grid-row">
          <div class="ms-Grid-col ms-sm2 ms-lg2">
            <span><i class="ms-Icon ms-Icon--WarningSolid"></i></span>
          </div>
          <div class="ms-Grid-col ms-sm10 ms-lg10">
            <p
              class="ms-Dialog-subText ms-Dialog-subText-notify modal__notify-text"
            >
              ¿Desea cerrar sesión?
            </p>
          </div>
        </div>
      </div>
      <div class="ms-Dialog-actions">
        <app-button buttonClass="ms-Dialog-action" buttonId="btnCancel" (buttonClick)="close()" label="Cancelar"></app-button>
        <app-button buttonClass="ms-Dialog-action ms-Button--primary" buttonId="btnLogOut" (buttonClick)="onLogOut()" label="Cerrar Sesión"></app-button> 
      </div>
    </div>
  </div>
</div>
